// @vendors
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');
const moment = require('moment');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const {mifidDisclaimersResponse} = require('mifid/actions/brokerConvenienceMiFIDTest');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const {
    BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_DISCRIMINADOR_CLAUSULA,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_ALERT_BUY_BUTTON_STOCK,
    CHARGE_ACCOUNT_PREFIX,
    DATE_FORMAT_API,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_ORDER_TYPE_EXCHANGE,
    BROKER_CORPORATE_OPERATIONS_CANJE_PRODUCT_TYPE,
    BROKER_CORPORATE_OPERATIONS_RIGHTS_BUY_ORDER_CONDITION
} = require('constants/index');

const actionTypes = require('constants/actionTypes');
const CHANGE_AGENT_ID = 'WEB';

const changeTitlesAmount = (titles) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_CHANGE_TITLES_AMOUNT,
        payload: { titles }
    });
};

const setVisibleStep = step => ({
    type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateStep = step => ({
    type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_VALIDATE_STEP,
    payload: {
        step
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const startOperation = (owner, contract, operation, associatedAccount, cuenta, walletAccountType, index, isLoaded) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_START_OPERATION,
        payload: {
            owner,
            contract,
            operation,
            associatedAccount,
            cuenta,
            walletAccountType,
            index,
            isLoaded
        }
    });
};

const confirmOperationCheckbox = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_CHANGE_OPERATION_CHECKBOX,
        payload: {}
    });
};

const successOperation = (response) => {
    return {
        type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SUCCESS,
        payload: { response }
    };
};

const failureOperation = (error) => {
    return {
        type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_FAILURE,
        payload: { error }
    };
};

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const storeDocument = (requestFinancialOperationChangeResponse, history) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const immBrokerRequestFinancialOperationChange = getState().brokerRequestFinancialOperationChange;
    const immBrokerProductFile = getState().brokerProductFile;

    const immContract = immCorporatesOperations.get('selectedContract');
    const selectedCorporateOperationIndex = immBrokerRequestFinancialOperationChange.get('selectedCorporateOperationIndex');
    const immOperation = immCorporatesOperations.getIn([
        'selectedContract',
        'operations',
        selectedCorporateOperationIndex
    ]);

    const orderId = trim(get(requestFinancialOperationChangeResponse, 'numeroOrden'));
    const orderTimestamp =
        get(requestFinancialOperationChangeResponse, 'timestamp') ||
        get(requestFinancialOperationChangeResponse, 'timeResponse.timestamp');

    const momentEmittedDateTime = momentTz(Number(orderTimestamp)).tz("Europe/Madrid");

    const controlDigit = trim(immContract.getIn(['cuenta', 'digitodecontrol']));
    const productNumber = trim(immContract.getIn(['contract', 'product']));
    const contractNumber = trim(immContract.getIn(['contract', 'number']));
    const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;

    const owner = trim(immContract.get('owner'));
    const momentEndDate = moment(immOperation.get('endDate'));

    const titlesAmount = immBrokerRequestFinancialOperationChange.getIn(['steps', FIRST_STEP, 'titlesAmount']);
    const sharesNumber = Number(titlesAmount) || 0;

    const marketName = trim(immBrokerProductFile.get('marketName'));
    const productAmount = Number(immBrokerProductFile.getIn(['productValue','amount'])) || 0;
    const currency = trim(immBrokerProductFile.get('currency'));
    const sharesAmount = productAmount * sharesNumber;

    const query = {
        productKID: '',
        contract: '',
        marketingReport: '',
        infoCcv: '',
        sendOrder: 'No',
        idOrder: orderId,
        market: marketName,
        termValidity: momentEndDate.format(DATE_FORMAT_API),
        holders: owner,
        leafletSusbcription: trim(immOperation.get('linkTriptico')),
        cnmvDocumentation: trim(immOperation.get('linkCNMV')),
        ccv: idContract,
        ccc: trim(get(requestFinancialOperationChangeResponse, 'cuentaAsociada.codbban')),
        idContract: idContract,
        email: trim(PersonalDataHelper.getEmail(immProfile)),
        clientAlias: trim(immProfile.get('nombreCliente')),
        isin: trim(immOperation.get('isin')),
        isinDescribe: trim(immOperation.get('descriptionValue')),
        channel: CONNECTION_CHANNEL_INTERNET,
        orderType: BROKER_ORDER_TYPE_EXCHANGE,
        productType: BROKER_CORPORATE_OPERATIONS_CANJE_PRODUCT_TYPE,
        sharesNumber,
        sharesAmount,
        orderCondition: BROKER_CORPORATE_OPERATIONS_RIGHTS_BUY_ORDER_CONDITION,
        conditionPrize : '',
        currency: currency,
        mifidWarningText: generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        dateTime: momentEmittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    const url = apiURLBuilder.getURL('communication');

    APIPost(dispatch, url, { query }).catch(() => dispatch(errorActions.show('', true, history)));
}

const performFinancialOperation = (dispatch, getState, token, validationResponse, history) => {
    const immBrokerRequestFinancialOperationChange = getState().brokerRequestFinancialOperationChange;
    const immProductFile = getState().brokerProductFile;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');
    const immOperacion = immBrokerRequestFinancialOperationChange.get('valor');
    const immCuentaAsociada = immBrokerRequestFinancialOperationChange.get('cuentaAsociada');
    const immContrato = immBrokerRequestFinancialOperationChange.get('contrato');
    const titlesQuantity = immBrokerRequestFinancialOperationChange.getIn(['steps', FIRST_STEP, 'titlesAmount']);
    const selectedCorporateOperationIndex = immBrokerRequestFinancialOperationChange.get(
        'selectedCorporateOperationIndex'
    );
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const selectedCorporateOperation = immCorporatesOperations.getIn([
        'selectedContract',
        'operations',
        selectedCorporateOperationIndex
    ]);
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const unitPrice = immProductFile.getIn(['productValue', 'amount'], 0);
    const productManager = immProductFile.get('companyName', '');
    const url = apiURLBuilder.getURL('brokerCanje');

    const requestObject = {
        header: {
            version: 2
        },
        query: {
            claseMarcaje: get(validationResponse, 'claseMarcaje'),
            codigoEmision: immOperacion.get('codigoEmision'),
            codigoGrupoSector: get(validationResponse, 'codigoGrupoSector'),
            codigoValorInterno: immOperacion.get('codigoValorInterno'),
            contrato: {
                numerodecontrato: immContrato.get('number'),
                producto: immContrato.get('product')
            },
            dataToken: token,
            digitoCuentaValores: immBrokerRequestFinancialOperationChange.get('digitodecontrol'),
            importeMovimiento: {
                divisa: immCuentaAsociada.getIn(['balance', 'currency']),
                importe: 0
            },
            subtipoProceso: immOperacion.get('subtipoProceso'),
            tipoMercado: get(validationResponse, 'tipoMercado'),
            tipoProceso: immOperacion.get('tipoProceso'),
            agentId: CHANGE_AGENT_ID,
            convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
            disclaimers: mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
            evaluateRegistry: mifidWasApplied,
            initQuantity: Number(titlesQuantity) || 0,
            marketTargetRegistry: mifidScore >= mifidScoring,
            micCode: trim(selectedCorporateOperation.get('iso')),
            necessaryConvenienceTestNote: mifidScoring,
            necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
            productIsin: trim(selectedCorporateOperation.get('isin')),
            productManager: productManager,
            productType: BROKER_ALERT_BUY_BUTTON_STOCK,
            reduceRisk: '',
            shares: Number(titlesQuantity) || 0,
            testConveniencyResult: mifidScore,
            unitPrice: unitPrice,
            documentationId: uuid
        }
    };

    APIPost(dispatch, url, requestObject)
        .then((response) => {
            dispatch(successOperation(response));
            dispatch(storeDocument(response, history))
        })
        .catch((error) => {
            dispatch(failureOperation(error));
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        })
};

const validateSignature = (dispatch, getState, validationResponse, history) => {
    signaturePatternActions.validateAndExecute(
        dispatch,
        getState,
        (dispatch, getState, token) => performFinancialOperation(dispatch, getState, token, validationResponse, history)
    );
};

const validateFinancialOperation = (dispatch, getState, history) => {
    const immBrokerRequestFinancialOperationChange = getState().brokerRequestFinancialOperationChange;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const selectedContract = immCorporatesOperations.get('selectedContract');
    const immContrato = immBrokerRequestFinancialOperationChange.get('contrato');
    const immValor = immBrokerRequestFinancialOperationChange.get('valor');
    const url = apiURLBuilder.getURL('brokerFinancialOperationsValidation');

    const requestData = {
        contrato: {
            numerodecontrato: immContrato.get('number'),
            producto: immContrato.get('product')
        },
        discriminadorClausula: BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_DISCRIMINADOR_CLAUSULA,
        fechaInicioOperacion: immValor.get('startDate'),
        codigoValorInterno: immValor.get('codigoValorInterno'),
        codigoEmision: immValor.get('codigoEmision'),
        cuentaAsociada: {
            codbban: selectedContract.getIn(['associatedAccount', 'number']).trim(),
            digitodecontrol: immBrokerRequestFinancialOperationChange.get('digitodecontrol'),
            pais: selectedContract.getIn(['associatedAccount', 'pais'])
        },
        descripcionSubproceso: immValor.get('descriptionProcess').trim(),
        links: [{
            href: selectedContract.getIn(['links', 'href']),
            rel: '',
            templated: true
        }],
        saldoCuentaAsociada: {
            divisa: selectedContract.getIn(['associatedAccount', 'balance', 'currency']),
            importe: selectedContract.getIn(['associatedAccount', 'balance', 'amount'])
        },
        subtipoProceso: immValor.get('subtipoProceso'),
        tipoMercado: immValor.get('iso'),
        tipoProceso: immValor.get('tipoProceso')
    };

    APIPost(dispatch, url, { query: requestData })
        .then((response) => {
            validateSignature(dispatch, getState, response, history)
        })
        .catch((error) => {
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        });
};

const submitOperation = (history) => (dispatch, getState) => {
    const error = getState().signaturePattern.get('showWarningSMS');
    const valid = getState().brokerRequestFinancialOperationChange.getIn(['steps', SECOND_STEP, 'valid']);

    if(error) {
        dispatch(failureOperation());
    } else if(valid) {
        validateFinancialOperation(dispatch, getState, history);
    }
};

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_DOCUMENTS_READ
});

module.exports = {
    startOperation,
    confirmOperationCheckbox,
    submitOperation,
    setVisibleStep,
    validateStep,
    changeTitlesAmount,
    setWillCancel,
    setDocumentsRead
};
